import { render } from "./list-service.vue?vue&type=template&id=a3d39c1c"
import script from "./list-service.vue?vue&type=script&lang=js"
export * from "./list-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__